export enum RequisitionProductSource {
    CATALOGUE = 'CATALOGUE',
    VESSEL_PRODUCTS = 'VESSEL_PRODUCTS',
}
